import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./App.css";
import Layout from "./components/Shared/Layout";
import Login from "./components/Authentication/login";
import ForgotPassword from "./components/Authentication/forgot-password";
import ProtectedRoute from "./routers/ProtectedRoute";
import { ROUTE_BASE_URL } from "./api/common";
import ChangePassword from "./components/Authentication/change-password";
import EventCalender from "./components/EventUsers/EventCalender";
import RegisterationMain from "./components/Authentication/Registermain/RegisterationMain";
import UserLogin from "./components/EventUsers/Authentication/login";
import UserForgotPassword from "./components/EventUsers/Authentication/forgot-password";
import UserChangePassword from "./components/EventUsers/Authentication/change-password";
import UserEvents from "./components/EventUsers/UserEventCalender";
import EventInvoiceMobile from "./components/EventUsers/invoice/invoice-mobile";
import UserEventQRPreview from "./components/EventUsers/UserEventQrPreview";
import UserEventPreview from "./components/EventUsers/UserEventPreviewPage";
import BadgeList from "./components/Event/Badge/BadgeList";
// import successPage from './components/Authentication/Registermain/success-page'
import failurePage from "./components/Authentication/Registermain/failure-page";
import { RegistrationProvider } from "../src/context/RegistrationContext";
import CheckInList from "./components/Event/AttendeesCheckin/check-in-list";
import CheckInDetails from "./components/Event/AttendeesCheckin/check-in-details";

const HomeRedirect = () => {
  const history = useHistory();
  useEffect(() => {
    history.replace("/events/event-calender");
  }, [history]);
  return null;
};

const EventsRedirect = () => {
  const history = useHistory();
  useEffect(() => {
    history.replace("/events/event-calender");
  }, [history]);
  return null;
};

class App extends Component {
  render() {
    const {
      themeColor,
      fontStyle,
      lightVersion,
      RtlVersion,
      offcanvas,
      miniSidebar,
      horizontalMenu,
      miniHover,
    } = this.props;
    document.body.className = `${themeColor} ${fontStyle}${
      lightVersion ? " light_version" : ""
    }${RtlVersion ? " rtl" : ""}${offcanvas ? " offcanvas-active" : ""}${
      horizontalMenu ? " h-menu" : ""
    }${miniSidebar ? " mini_sidebar" : ""}${miniHover ? " mini_hover" : ""}`;

    const isAuthenticated = !!localStorage.getItem("loginUserId");

    return (
      <div ref={(leftSidebar) => (this.leftSidebar = leftSidebar)}>
        <Router>
          <Switch>
            <Route exact path="/" component={HomeRedirect} />
            <Route exact path="/events" component={EventsRedirect} />
            <Route path={`${ROUTE_BASE_URL}/login`} component={Login} />
            <Route
              path={`${ROUTE_BASE_URL}/forgot-password`}
              component={ForgotPassword}
            />
            <Route
              path={`${ROUTE_BASE_URL}/change-password`}
              component={ChangePassword}
            />
            <Route
              path={`/events/user-event-preview`}
              component={UserEventQRPreview}
            />
            <Route
              path={`/events/user-event-details/:email/:eventId`}
              component={UserEventPreview}
            />
            <Route path={`/events/attendees-checkin-list/:id`} component={CheckInList} />
            <Route path={`/events/attendees-checkin-details/:id/:checkinId`} component={CheckInDetails} />
            <Route path={`/events/event-calender`} component={EventCalender} />
            <Route path={`/events/user-login`} component={UserLogin} />
            <Route path={`/events/user-events/:id`} component={UserEvents} />
            <Route
              path={`/events/user-event-invoice`}
              component={EventInvoiceMobile}
            />
            <Route
              path={`/events/user-forgot-password`}
              component={UserForgotPassword}
            />
            <Route
              path={`/events/user-change-password`}
              component={UserChangePassword}
            />
            {/* <Route path={`/events/success`} component={successPage} /> */}
            <Route path={`/events/failer`} component={failurePage} />
            <Route
              path="/events/registration/:eventSlug"
              exact
              render={(props) => (
                <RegistrationProvider>
                  <RegisterationMain {...props} />
                </RegistrationProvider>
              )}
            />
            <Route
              path="/events/registration/:eventSlug/:token"
              render={(props) => (
                <RegistrationProvider>
                  <RegisterationMain {...props} />
                </RegistrationProvider>
              )}
            />

            {/* <Route component={Layout} /> */}
            <ProtectedRoute
              path={ROUTE_BASE_URL}
              component={Layout}
              isAuthenticated={isAuthenticated}
            />
          </Switch>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  themeColor: state.settings.themeColor,
  fontStyle: state.settings.fontStyle,
  lightVersion: state.settings.lightVersion,
  RtlVersion: state.settings.RtlVersion,
  offcanvas: state.settings.offcanvas,
  horizontalMenu: state.settings.horizontalMenu,
  miniSidebar: state.settings.miniSidebar,
  miniHover: state.settings.miniHover,
});

export default connect(mapStateToProps)(App);